import { api } from "../../lib/api";
export const deleteAssetFromSite = async (projectId, assetId) => {
    const { data } = await api.patch(`/projects/${projectId}/assets/${assetId}/action:deleted`);
    return data;
};
export const ignoreAssetFromSite = async (projectId, assetId) => {
    const { data } = await api.patch(`/projects/${projectId}/assets/${assetId}/action:ignored`);
    return data;
};
